const HtmlMapper = () => {
    /**
     * 
     * @param {any} tipoElemento
     */
    function _obtenerTipoElemento(tipoElemento) {
        let base = {
            esSelect: false,
            esInputText: false,
            esInputCheck: false,
            esInputRadio: false,
            esInputDate: false,
            tipo: ""
        }

        switch (tipoElemento) {
            case "SELECT": {
                return { ...base, esSelect: true, tipo: "select" }
            }
            case "TEXT":
            case "TEXTAREA": {
                return { ...base, esInputText: true, tipo: "text" }
            }
            case "CHECK": {
                return { ...base, esInputCheck: true, tipo: "check" }
            }
            case "RADIO": {
                return { ...base, esInputRadio: true, tipo: "radio" }
            }
            case "DATETIME": {
                return { ...base, esInputDate: true, tipo: "datetime" }
            }
            default: {
                return base;
            }
        }
    }
    //Funciones públicas
    return {
        /**
         * 
         * @param {any} tipoElemento
         */
        ObtenerTipoElemento: (tipoElemento) => {
            return _obtenerTipoElemento(tipoElemento);
        }
    }
}

let htmlMapper = new HtmlMapper();
export default htmlMapper;


// WEBPACK FOOTER //
// ./Portico/Productos/Atlas/App/Common/Helpers/HtmlMapper.js